import other_en from "./other-en.json";
import other_tc from "./other-tc.json";
import other_sc from "./other-sc.json";
import {
  CATEGORIES,
  MEDIA_TYPE,
  type PublicationType,
} from "../PublicationList_left";
import { Language } from "../../context";

/**
 * Converts raw JSON entries into standardized PublicationType objects.
 * Used for additional publications that do not fall under specific categories.
 *
 * @param jsonData - The raw JSON array from any language version
 * @returns An array of normalized PublicationType objects
 */

const processOtherJson = (jsonData: any[]): PublicationType[] => {
  return jsonData?.map((item) => ({
    title: item?.title ?? "",
    date: item?.date ?? "",
    link: item?.url ?? "",
    external: item?.external === "true",
    mediaType: item?.type as MEDIA_TYPE, // PDF
    thumbnail: item?.thumb ?? "",
    category: [CATEGORIES.PUBLICATIONS],
  }));
};

// Process other publication data by language
const other_list_en: PublicationType[] = processOtherJson(other_en);
const other_list_tc: PublicationType[] = processOtherJson(other_tc);
const other_list_sc: PublicationType[] = processOtherJson(other_sc);

/**
 * Maps each supported language to its corresponding list of miscellaneous publications.
 */
export const otherListLanguageMap: Record<Language, PublicationType[]> = {
  [Language.EN]: other_list_en,
  [Language.TC]: other_list_tc,
  [Language.SC]: other_list_sc,
};
